import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Calendar } from "lucide-react";

// Mock data for assigned consultant
const assignedConsultant = {
  id: 1,
  name: "Dr. Sarah Johnson",
  title: "Senior Immigration Consultant",
  specialization: "Global Talent Visa",
  status: "Available",
  imageUrl: "/lovable-uploads/40412cbb-dfc0-4d5e-9eb8-96437e121af6.png",
  expertise: ["Tech Immigration", "Academic Pathways", "Research Visas"],
  languages: ["English", "French"],
  nextAvailable: "Today"
};

const AssignedConsultant = () => {
  const handleBookConsultation = () => {
    window.open('https://cal.com/navisa-global/consultation', '_blank');
  };

  return (
    <Card className="bg-card/50 backdrop-blur-sm">
      <CardHeader>
        <CardTitle>Your Immigration Consultant</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex flex-col md:flex-row items-start gap-6">
          {/* Consultant Image & Basic Info */}
          <div className="flex items-start gap-4">
            <img
              src={assignedConsultant.imageUrl}
              alt={assignedConsultant.name}
              className="w-16 h-16 rounded-full object-cover"
            />
            <div>
              <h3 className="font-semibold text-lg">{assignedConsultant.name}</h3>
              <p className="text-muted-foreground">{assignedConsultant.title}</p>
              <p className="text-sm text-muted-foreground mt-1">
                Specializes in {assignedConsultant.specialization}
              </p>
            </div>
          </div>

          {/* Expertise & Languages */}
          <div className="flex-1 space-y-4">
            <div>
              <h4 className="text-sm font-medium mb-2">Expertise</h4>
              <div className="flex flex-wrap gap-2">
                {assignedConsultant.expertise.map((exp, index) => (
                  <Badge key={index} variant="secondary">
                    {exp}
                  </Badge>
                ))}
              </div>
            </div>
            <div>
              <h4 className="text-sm font-medium mb-2">Languages</h4>
              <p className="text-sm text-muted-foreground">
                {assignedConsultant.languages.join(", ")}
              </p>
            </div>
          </div>

          {/* Booking Section */}
          <div className="flex flex-col items-end gap-4">
            <div className="text-right">
              <p className="text-sm font-medium">Next Available</p>
              <p className="text-muted-foreground">{assignedConsultant.nextAvailable}</p>
            </div>
            <Button
              onClick={handleBookConsultation}
              className="whitespace-nowrap"
            >
              <Calendar className="mr-2 h-4 w-4" />
              Book Consultation
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default AssignedConsultant;